import { RouterProvider, createRouter } from '@tanstack/react-router';
import { ErrorBoundary } from 'react-error-boundary';

import { routeTree } from './routeTree.gen';
import { Providers } from './providers/index';
import { logger } from './shared/lib/logger';

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function AppErrorFallback({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : 'Unknown error';
  logger.error('App-level error boundary caught', error);
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground p-8">
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-bold text-destructive">Application Error</h1>
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}

export function App() {
  return (
    <ErrorBoundary FallbackComponent={({ error }) => <AppErrorFallback error={error} />}>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  );
}
